import { smartDocStaticParamType_Attribute } from './attribute/index.js';
import { smartDocStaticParamType_ChiefComplaint } from './chief-complaint/index.js';
import { smartDocStaticParamType_ContextRule } from './context-rule/index.js';
import { smartDocStaticParamType_Factor } from './factor/index.js';
import { smartDocStaticParamType_Finding } from './finding/index.js';
import { smartDocStaticParamType_MDM } from './mdm/index.js';
import { smartDocStaticParamType_Orders } from './orders/index.js';
import { smartDocStaticParamType_PhysicianNotes } from './physician-notes/index.js';
import { smartDocStaticParamType_SmartMDM } from './smart-mdm/index.js';
import { smartDocStaticParamType_Tag } from './tag/index.js';
import { smartDocStaticParamType_Template } from './template/index.js';
import { smartDocStaticParamType_Time } from './time/index.js';
export * from './attribute/types.js';
export * from './chief-complaint/types.js';
export * from './factor/types.js';
export * from './finding/types.js';
export * from './tag/types.js';
export * from './template/types.js';
export * from './orders/types.js';
export * from './physician-notes/types.js';
export * from './mdm/types.js';
export * from './context-rule/types.js';
export const smartDocStaticParamTypes = [
    smartDocStaticParamType_Tag,
    smartDocStaticParamType_Finding,
    smartDocStaticParamType_ChiefComplaint,
    smartDocStaticParamType_Attribute,
    smartDocStaticParamType_Factor,
    smartDocStaticParamType_Template,
    smartDocStaticParamType_Orders,
    smartDocStaticParamType_PhysicianNotes,
    smartDocStaticParamType_MDM,
    smartDocStaticParamType_ContextRule,
    smartDocStaticParamType_SmartMDM,
    smartDocStaticParamType_Time,
];
//# sourceMappingURL=types.js.map